import { render, staticRenderFns } from "./CaptureFrameOverlay.vue?vue&type=template&id=226e5574&scoped=true"
import script from "./CaptureFrameOverlay.vue?vue&type=script&lang=js"
export * from "./CaptureFrameOverlay.vue?vue&type=script&lang=js"
import style0 from "./CaptureFrameOverlay.vue?vue&type=style&index=0&id=226e5574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e5574",
  null
  
)

export default component.exports